import { useEffect, useRef, useState } from "react";

export const useScrollFadeIn = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Fallback: make visible after 1 second regardless
    const timeout = setTimeout(() => setIsVisible(true), 1000);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          clearTimeout(timeout);
          observer.unobserve(el);
        }
      },
      { threshold: 0.05, rootMargin: "50px" }
    );
    observer.observe(el);
    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, []);

  return {
    ref,
    className: `transition-all duration-700 ease-out ${
      isVisible ? "opacity-100 translate-y-0" : "opacity-100 translate-y-[10px]"
    }`,
  };
};
